import PhotoCrop from './PhotoCrop';

export default PhotoCrop;
